import { ElementRef, inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, fromEvent, map, pairwise } from 'rxjs';

import { Tab } from '../components/tabs-header/models/tabs.model';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private scrollElement!: Element;
  readonly #router = inject(Router);

  tabScrollOption = signal({ tabId: '', position: 0 });

  scroll$ = fromEvent(window, 'scroll');

  scrollPosition = toSignal(this.scroll$.pipe(map(() => window.scrollY)), { initialValue: 0 });

  scrollDirection = toSignal(
    this.scroll$.pipe(
      map(() => window.scrollY),
      pairwise(),
      map(([prev, next]) => (next > prev ? 'down' : 'up'))
    ),
    { initialValue: 'down' }
  );

  setScrollElement(element: Element) {
    this.scrollElement = element;
  }

  scrollToTop(top: number = 0, behavior?: 'auto' | 'smooth') {
    setTimeout(() => {
      this.scrollElement.scrollTo({
        top: top,
        behavior: behavior ?? 'smooth'
      });
    }, 100);
  }

  scrollTo(top: number = 0, behavior: 'auto' | 'smooth' = 'smooth') {
    window.scrollTo({
      top,
      behavior
    });
  }

  setTabScrollOption(tab: Tab, tabsEl: ElementRef, offset?: number) {
    const absoluteTop = tabsEl.nativeElement.getBoundingClientRect().top + (window.scrollY - (offset ?? 50));
    const tabOption = {
      tabId: tab.content.guidId,
      position: absoluteTop ?? 0
    };
    this.tabScrollOption.set(tabOption);
  }

  routeScrollToTop() {
    this.#router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((page: any) => {
      let yPositionToScroll = 0;
      const urlParams = new URLSearchParams(page.urlAfterRedirects.split('?')[1]);
      const tabValue = urlParams.get('tab');
      if (tabValue == this.tabScrollOption().tabId) {
        yPositionToScroll = this.tabScrollOption().position;
      }
      window.scrollTo({ top: yPositionToScroll });
    });
  }
}
